// removed by extract-text-webpack-plugin
module.exports = {"bp":"(min-width: 700px)","black":"#000000","darkGradient":"radial-gradient(#002A3B 0%, #00171F 94.96%)","wrapper":"src-components-LogoGrid----LogoGrid-module---wrapper---3ZTiD","logoList":"src-components-LogoGrid----LogoGrid-module---logoList---s1dJO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LogoGrid/LogoGrid.module.css
// module id = 207
// module chunks = 35783957827783 114276838955818